import styled from 'styled-components'
// libs
import { lighten } from 'polished'
// themes
import { colors } from 'themes'

export enum LastUpdatedVariant {
  // On the dark page header
  Dark = 'dark',
  // On a white card
  Light = 'light'
}

const LAST_UPDATED_COLORS: Record<LastUpdatedVariant, { caption: string; value: string }> = {
  [LastUpdatedVariant.Dark]: { caption: lighten(0.12, colors.gray850), value: colors.gray220 },
  [LastUpdatedVariant.Light]: { caption: lighten(0.15, colors.gray850), value: colors.darkBlue400 }
}

// Two lines, the caption over the time, read in that order as one phrase
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.25;
  white-space: nowrap;
`

export const Caption = styled.span<{ variant: LastUpdatedVariant }>`
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ variant }) => LAST_UPDATED_COLORS[variant].caption};
`

export const Value = styled.span<{ variant: LastUpdatedVariant }>`
  font-size: 13px;
  font-weight: 400;
  color: ${({ variant }) => LAST_UPDATED_COLORS[variant].value};
`
